<template>
  <div v-if="isShowMenu">
    <kendo-menu :items="items" @select="onSelect" :selectedKey="selectedItemID" :vertical="true" />
  </div>
</template>
<script>
import { Menu } from "@progress/kendo-vue-layout";
import { getMessageByLang } from "@/utils/translate.js";
import { getUrlWithRole } from '@/utils/router';

export default {
  props: {
    currentTheme: String,
  },
  components: {
    "kendo-menu": Menu,
  },
  inject: {
    kendoLocalizationService: { default: null },
  },
  data() {
    return {
      getMessageByLang: getMessageByLang,
      getUrlWithRole: getUrlWithRole,
      isShowMenu: false,
      teamClass: "",
      dashboardClass: "",
      usersClass: "",
      suppliersClass: "",
      profileClass: "",
      bannersClass: '',
      infoClass: "disabled",
      logoutClass: "",
      productsClass: "",
      servicesClasses: "",
      paymentsClass: "",
      ordersClass: "",
      tagsClass: "",
      logsClass: "",
      selectedItemID: null,
      disabledPath: ["/Info"],
    };
  },
  computed: {
    items() {
      const listAll = [
        {
          text: this.getMessageByLang("usersText", "Пользователи"),
          cssClass: this.usersClass,
          cssStyle: {
            paddingBottom: "10px",
            paddingTop: "10px",
            paddingLeft: "5px",
          },
          icon: "k-icon k-i-tell-a-friend",
          data: {
            path: "/admin/users",
          },
          id: "users",
        },
        {
          text: this.getMessageByLang("suppliers", "Suppliers"),
          cssClass: this.suppliersClass,
          cssStyle: {
            paddingBottom: "10px",
            paddingTop: "10px",
            paddingLeft: "5px",
          },
          icon: "k-icon k-i-truck",
          data: {
            path: "/admin/suppliers",
          },
          id: "suppliers",
        },
        {
          text: this.getMessageByLang("categories", "Categories"),
          cssClass: this.categoriesClass,
          cssStyle: {
            paddingBottom: "10px",
            paddingTop: "10px",
            paddingLeft: "5px",
          },
          icon: "k-icon k-i-folder",
          data: {
            path: "/admin/categories",
          },
          id: "categories",
        },
        {
          text: this.getMessageByLang("products", "Products"),
          cssClass: this.productsClass,
          cssStyle: {
            paddingBottom: "10px",
            paddingTop: "10px",
            paddingLeft: "5px",
          },
          icon: "k-icon k-i-dictionary-add",
          data: {
            path: "/admin/products",
          },
          id: "products",
        },
        {
          text: this.getMessageByLang("servicesText", "Услуги"),
          cssClass: this.servicesClasses,
          cssStyle: {
            paddingBottom: "10px",
            paddingTop: "10px",
            paddingLeft: "5px",
          },
          icon: "k-icon k-i-dictionary-add",
          data: {
            path: "/admin/services",
          },
          id: "services",
        },
        {
          text: this.getMessageByLang("ordersTxt", "Заказы"),
          cssClass: this.ordersClass,
          cssStyle: {
            paddingBottom: "10px",
            paddingTop: "10px",
            paddingLeft: "5px",
          },
          icon: "k-icon k-i-cloud",
          data: {
            path: "/admin/orders",
          },
          id: "orders",
        },
        {
          text: 'Баннеры',
          cssClass: this.bannersClass,
          cssStyle: {
            paddingBottom: "10px",
            paddingTop: "10px",
            paddingLeft: "5px",
          },
          icon: "k-icon k-i-comment",
          data: {
            path: "/admin/banners",
          },
          id: "banners",
        },
        {
          text: this.getMessageByLang("tags", "Теги"),
          cssClass: this.tagsClass,
          cssStyle: {
            paddingBottom: "10px",
            paddingTop: "10px",
            paddingLeft: "5px",
          },
          icon: "k-icon k-i-search",
          data: {
            path: "/admin/tags",
          },
          id: "tags",
        },
        {
          text: this.getMessageByLang("Logs", "Журнал событий"),
          cssClass: this.logsClass,
          cssStyle: {
            paddingBottom: "10px",
            paddingTop: "10px",
            paddingLeft: "5px",
          },
          icon: "k-icon k-i-grid",
          data: {
            path: "/admin/logs",
          },
          id: "logs",
        },
        {
          text: this.getMessageByLang("profile", "Профиль"),
          cssClass: this.profileClass,
          cssStyle: {
            paddingBottom: "10px",
            paddingTop: "10px",
            paddingLeft: "5px",
          },
          icon: "k-icon k-i-user",
          data: {
            path: "/admin/profile",
          },
          id: "profile",
        },
        {
          text: this.getMessageByLang("logout", "logout"),
          cssClass: this.logoutClass,
          cssStyle: {
            borderTop: "1px solid red",
            paddingBottom: "10px",
            paddingTop: "10px",
            paddingLeft: "5px",
          },
          icon: "k-icon k-i-logout",
          data: {
            path: "/logout",
          },
          id: 10,
        },
      ];

      const listSupplier = [
        {
          text: this.getMessageByLang("categories", "Categories"),
          cssClass: this.categoriesClass,
          cssStyle: {
            paddingBottom: "10px",
            paddingTop: "10px",
            paddingLeft: "5px",
          },
          icon: "k-icon k-i-folder",
          data: {
            path: "/supplier/categories",
          },
          id: "categories",
        },
        {
          text: this.getMessageByLang("products", "Products"),
          cssClass: this.productsClass,
          cssStyle: {
            paddingBottom: "10px",
            paddingTop: "10px",
            paddingLeft: "5px",
          },
          icon: "k-icon k-i-dictionary-add",
          data: {
            path: "/supplier/products",
          },
          id: "products",
        },
        {
          text: this.getMessageByLang("servicesText", "Услуги"),
          cssClass: this.servicesClasses,
          cssStyle: {
            paddingBottom: "10px",
            paddingTop: "10px",
            paddingLeft: "5px",
          },
          icon: "k-icon k-i-dictionary-add",
          data: {
            path: "/supplier/services",
          },
          id: "services",
        },
        {
          text: this.getMessageByLang("profile", "Профиль"),
          cssClass: this.profileClass,
          cssStyle: {
            paddingBottom: "10px",
            paddingTop: "10px",
            paddingLeft: "5px",
          },
          icon: "k-icon k-i-user",
          data: {
            path: "/supplier/profile",
          },
          id: "profile",
        },
        {
          text: this.getMessageByLang("logout", "logout"),
          cssClass: this.logoutClass,
          cssStyle: {
            borderTop: "1px solid red",
            paddingBottom: "10px",
            paddingTop: "10px",
            paddingLeft: "5px",
          },
          icon: "k-icon k-i-logout",
          data: {
            path: "/logout",
          },
          id: 10,
        },
      ];

      const listClient = [
        {
          text: this.getMessageByLang("ordersTxt", "Заказы"),
          cssClass: this.ordersClass,
          cssStyle: {
            paddingBottom: "10px",
            paddingTop: "10px",
            paddingLeft: "5px",
          },
          icon: "k-icon k-i-dictionary-add",
          data: {
            path: "/client/orders",
          },
          id: "orders",
        },
        {
          text: this.getMessageByLang("profile", "Профиль"),
          cssClass: this.profileClass,
          cssStyle: {
            paddingBottom: "10px",
            paddingTop: "10px",
            paddingLeft: "5px",
          },
          icon: "k-icon k-i-user",
          data: {
            path: "/client/profile",
          },
          id: "profile",
        },
        {
          text: this.getMessageByLang("logout", "logout"),
          cssClass: this.logoutClass,
          cssStyle: {
            borderTop: "1px solid red",
            paddingBottom: "10px",
            paddingTop: "10px",
            paddingLeft: "5px",
          },
          icon: "k-icon k-i-logout",
          data: {
            path: "/logout",
          },
          id: 10,
        },
      ];

      const role = getUrlWithRole();
      switch (role) {
        case "supplier/":
          return listSupplier;

        case "client/":
          return listClient;

        default:
          return listAll;
      }
    },
  },
  methods: {
    onSelect(e) {
      if (!this.disabledPath.includes(e.item.data.path)) {
        this.$router.push(e.item.data);
        this.selectedItemID = e.item.id;
        this.updateSelectedMenuItem(e.item.id);
      }
    },
    updateSelectedMenuItem(menuItemID) {
      if (!menuItemID) return;

      this.dashboardClass =
        menuItemID === "dashboard"
          ? this.currentTheme + " k-state-selected"
          : this.currentTheme;
      this.usersClass =
        menuItemID === "users"
          ? this.currentTheme + " k-state-selected"
          : this.currentTheme;
      this.suppliersClass =
        menuItemID === "suppliers"
          ? this.currentTheme + " k-state-selected"
          : this.currentTheme;
      this.categoriesClass =
        menuItemID === "categories"
          ? this.currentTheme + " k-state-selected"
          : this.currentTheme;
      this.productsClass =
        menuItemID === "products"
          ? this.currentTheme + " k-state-selected"
          : this.currentTheme;
      this.servicesClasses =
        menuItemID === "services"
          ? this.currentTheme + " k-state-selected"
          : this.currentTheme;
      this.productsClass === "productEdit"
        ? this.currentTheme + " k-state-selected"
        : this.currentTheme;
      this.profileClass =
        menuItemID === 'profile'
          ? this.currentTheme + " k-state-selected"
          : this.currentTheme + " ";
      this.bannersClass =
        menuItemID === 'banners'
          ? this.currentTheme + " k-state-selected"
          : this.currentTheme + " ";
      this.ordersClass =
        menuItemID?.toString()?.toLowerCase() === "orders"
          ? this.currentTheme + " k-state-selected "
          : this.currentTheme + " ";

      this.paymentsClass =
        menuItemID?.toString()?.toLowerCase() === "payments"
          ? this.currentTheme + " k-state-selected"
          : this.currentTheme + " ";

      this.infoClass =
        menuItemID === 4
          ? this.currentTheme + " k-state-selected"
          : this.currentTheme + " ";
      this.logoutClass =
        menuItemID === 10
          ? this.currentTheme + " k-state-selected"
          : this.currentTheme;
      this.tagsClass =
        menuItemID === 'tags'
          ? this.currentTheme + " k-state-selected"
          : this.currentTheme;

      this.logsClass =
        menuItemID === 'logs'
          ? this.currentTheme + " k-state-selected"
          : this.currentTheme;
    },
    setActiveMenu() {
      const activeMenu = this.$route.name;
      let routeName = activeMenu;

      if (routeName.toLowerCase() === 'order') {
        this.selectedItemID = "orders";
        routeName = 'orders';
      }

      if (['AdminBanners', 'AdminBanner'].includes(routeName)) {
        this.selectedItemID = 'banners';
        routeName = 'banners';
      }

      if (['productEdit', 'productCreate'].includes(routeName)) {
        this.selectedItemID = "products";
        routeName = 'products';
      }

      if (['Tag'].includes(routeName)) {
        this.selectedItemID = 'tags';
        routeName = 'tags';
      }

      if (['Log', 'Logs'].includes(routeName)) {
        this.selectedItemID = 'logs';
        routeName = 'logs';
      }

      this.updateSelectedMenuItem(routeName.toLowerCase());
      this.isShowMenu = true;
    },
  },
  mounted() {
    this.setActiveMenu();
    this.isShowMenu = true;
  },
};
</script>
<style>
@import "https://unpkg.com/@progress/kendo-font-icons/dist/index.css";
</style>